"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var CircularProgress_1 = __importStar(require("@mui/material/CircularProgress"));
var styles_1 = require("@mui/material/styles");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var CircleTemplate = (0, styles_1.styled)(CircularProgress_1.default)(function (_a) {
    var _b;
    var _c;
    var theme = _a.theme;
    return (_b = {
            borderRadius: 10,
            color: (_c = theme.palette.neutral) === null || _c === void 0 ? void 0 : _c.light
        },
        _b["& .".concat(CircularProgress_1.circularProgressClasses.circleDeterminate)] = {
            borderRadius: 10,
            strokeLinecap: 'round',
        },
        _b);
});
var CircleGradient = (0, styles_1.styled)(CircularProgress_1.default)(function () {
    var _a;
    return (_a = {
            position: 'absolute',
            left: 0
        },
        _a["& .".concat(CircularProgress_1.circularProgressClasses.circle)] = {
            strokeLinecap: 'round',
            stroke: 'url(#linearColors)',
        },
        _a);
});
var StyledHeader = (0, styles_1.styled)(Heading_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        fontSize: theme.spacing(8.25),
        color: theme.palette.text.secondary,
        lineHeight: 1.0625,
    });
});
var CaptionWrapper = (0, styles_1.styled)('div')(function (_a) {
    var theme = _a.theme;
    return ({
        top: theme.spacing(3.75),
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        textAlign: 'center',
    });
});
var CircleGraph = function (_a) {
    var title = _a.title, value = _a.value, size = _a.size;
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ mr: 8, position: "relative", display: "inline-flex" }, { children: [(0, jsx_runtime_1.jsx)(CircleTemplate, { variant: "determinate", size: size, thickness: 3, value: 94, disableShrink: true }), (0, jsx_runtime_1.jsx)("svg", __assign({ width: 0, height: 0 }, { children: (0, jsx_runtime_1.jsxs)("linearGradient", __assign({ id: "linearColors", x1: "0", y1: "0", x2: "1", y2: "1" }, { children: [(0, jsx_runtime_1.jsx)("stop", { offset: "20%", stopColor: "#23AFEE" }), (0, jsx_runtime_1.jsx)("stop", { offset: "80%", stopColor: "#FF9FBF" })] })) })), (0, jsx_runtime_1.jsx)(CircleGradient, { variant: "determinate", disableShrink: true, value: Math.round(value), size: size, thickness: 3, color: "primary" }), (0, jsx_runtime_1.jsxs)(CaptionWrapper, { children: [(0, jsx_runtime_1.jsx)(StyledHeader, __assign({ level: 1 }, { children: Math.round(value) })), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption" }, { children: title }))] })] })));
};
exports.default = CircleGraph;
